// =====================================================================================================================
// RESUME VIEW
//
//  The portfolio resume show and download page
//

import { GridContainer, Ui } from "@stratisopt/platform";
import { UiFactory } from "@stratisopt/platform";

export class ResumeView extends GridContainer {

    // =================================================================================================================
    // CONSTRUCTORS
    //

    // Create and initialize a new instance
    public static create():ResumeView {
        let ui = new ResumeView();
        ui.init();
        return ui;
    }

    // Initialize this instance
    public init() {

        // Initialize the super
        super.init(this._json);
        UiFactory.addChildren(this, this._json);
    }


    // =================================================================================================================
    // VIEW
    //

    private _json = {
        name:'resumeView', publicName:'Résumé', sizeX:'100%', sizeY:'100%', alignContentY:'MIN',
        backColor:'black', textcolor:Ui.theme.COLOR_FontNeutral,
        textSizePlatform:Ui.theme.SIZE_FontNeutral,
        children:[
         
            {type:'V_CONTAINER', sizeX:'100%', sizeY:'100%', children:[
                {sizeX:'1*', sizeY:'1*', 
                    effect:'drift embers',
                    backColor:'url("/assets/image/my-bob-ross-dark-forrest.jpg")', backPos:'right top', backFit:'cover'
                },
            ]},
           

            {type:'V_CONTAINER', sizeX:'1*', sizeY:'1*', alignContentX:'mid', children:[
                
                {type:'H_CONTAINER', pad:'10px',alignSelfX:'min', cursor:'pointer', onTouch:'App.Show homeView', alignContentY:'mid', children:[
                    {type:'H_CONTAINER', pad:Ui.theme.SPACING_Neutral, children:[
                        {type:'text', textSize:Ui.theme.SIZE_FontEmphasize, textShadow:Ui.theme.COLOR_FontShadow, textColor:Ui.theme.COLOR_FontNeutral, value:'Résumé'},
                    ]},
                    {type:'image', sizeX:'64px', sizeY:'64px',  value:'/assets/image/Logo.png'},
                ]},
                {type:'V_CONTAINER', sizeX:'1*', sizeY:'1*',scrollShowY:'true', alignContentX:'mid', children:[
                    {type:'G_CONTAINER', pad:Ui.theme.SPACING_Nest, sizeX:'1*', alignContentX:'mid', children:[
                        {type:'V_CONTAINER', alignContentX:'mid', sizeX:'1*', children:[
                            {sizeY:'21.35px'},
                            {type:'V_CONTAINER', pad:Ui.theme.SPACING_Nest, sizeX:'1*', sizeMaxX:'650px',children:[
                                {type:'image', sizeX:'1*', backPos:'mid min', backFit:'contain', value:'/assets/image/CV.webp'}
                            ]}
                        ]},
                        {type:'V_CONTAINER', borderRadius:Ui.theme.BORDER_Rounded, pad:Ui.theme.SPACING_Neutral, backColor:Ui.theme.COLOR_ActionButton,
                            cursor:'pointer', effect:'hover',
                            onTouch:'Ui.download /assets/documents/Toph-Ballinger-Resume-2026.pdf', 
                            children:[
                                {type:'text', value:'Download PDF'}
                        ]}
                ]   }
                ]}
            ]},
        ]
    };

}
